module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABACAYAAADbER1AAAAAFklEQVQYlWM4efLkfyYGBgaGUYIcAgB4CgPZLdzJfQAAAABJRU5ErkJggg=="